import React from 'react';
import { formatCurrency } from '../../utils/formatters';

/**
 * "Needs recharge" card, shared by the Meta and Google performance screens.
 * The two differed only in their logo, the id prefix stripped before building
 * the deep link, and the button's colours, label and destination.
 */
const InactiveAccountCard = ({
  account,
  logo,
  logoWrapperClassName,
  buttonClassName,
  buttonLabel,
  idPrefix,
  buildUrl,
}) => {
  const accountId = (account.account_id || account.id)?.replace(idPrefix, '') || '';

  return (
    <div className="bg-[#09090B] rounded-xl border border-red-500/30 hover:border-red-500/50 transition-colors p-5">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className={logoWrapperClassName}>
            {logo}
          </div>
          <div>
            <h3 className="font-bold text-white">{account.account_name || account.name || `Account ${accountId}`}</h3>
            <div className="flex items-center gap-2 mt-1">
              <span className="px-2 py-0.5 bg-red-500/20 text-red-400 rounded-full text-xs font-semibold">
                Needs Recharge
              </span>
              <span className="text-xs text-zinc-500">
                Last active: {account.last_active_date || 'Unknown'}
              </span>
            </div>
          </div>
        </div>
        <div className="text-right">
          <p className="text-xs text-zinc-500 uppercase">Last Spend</p>
          <p className="text-xl font-bold text-red-400 font-mono">{formatCurrency(account.spend_2_days_ago)}</p>
        </div>
      </div>
      {account.alert_message && (
        <div className="mt-3 p-2 bg-red-500/10 border border-red-500/20 rounded-lg">
          <p className="text-xs text-red-300">{account.alert_message}</p>
        </div>
      )}
      <button
        className={`mt-3 w-full px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${buttonClassName}`}
        onClick={() => window.open(buildUrl(accountId), '_blank')}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default InactiveAccountCard;
